import { Injectable } from '@angular/core';

import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';

@Injectable()
export class PeticionesInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const isApi1 = request.url.includes(
      `${environment.microConfiguraciones}/locales/olo/`
    );

    const isApi2 = request.url.includes(
      `${environment.microConfiguraciones}/locales/cuenta/olo`)

    const authApiKey = isApi1 || isApi2 ? environment.globalapiKey : null;
    if (authApiKey) {
      const authReq = request.clone({
        headers: request.headers.set('Authorization', authApiKey),
      });
      return next.handle(authReq);
    } else {
      return next.handle(request);
    }
  }
}
